<div>
  <h3>1. Package</h3>
  <div>
    <h4>Version</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.packaging?.variant">Variant: {{composition?.packaging?.variant}}</mat-list-item>
      <mat-list-item *ngIf="composition?.packaging?.pakName">Pak name: {{composition?.packaging?.pakName}}</mat-list-item>
    </mat-list>
  </div>

  <div>
    <h4>Kiosk</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.desktopPlayer?.playerVersion">Player
        version: {{composition?.desktopPlayer?.playerVersion}}</mat-list-item>
      <mat-list-item *ngIf="composition?.desktopPlayer?.autoUpdate">Auto update: {{composition?.desktopPlayer?.autoUpdate}}</mat-list-item>
    </mat-list>
  </div>
</div>

<div>
  <h3>2. Screen</h3>
  <div>
    <h4>Available Languages</h4>
    <mat-list>
      <mat-list-item *ngFor="let lang of composition?.screen?.availableLanguages">
        <span class="fixed-width">{{availableLanguages[lang].title}}</span>
        <mat-icon *ngIf="composition?.screen?.disabledLanguages.indexOf(lang) > -1">indeterminate_check_box</mat-icon>
        <mat-icon *ngIf="composition?.screen?.disabledLanguages.indexOf(lang) === -1">check_box</mat-icon>
      </mat-list-item>
      <mat-list-item *ngIf="composition?.screen?.availableLanguages === null">Available languages from parent composition</mat-list-item>
    </mat-list>
  </div>
</div>

<div>
  <h3>3. Meta</h3>
  <div>
    <h4>Address</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.address?.title">{{composition?.address?.title}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.street">{{composition?.address?.street}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.zip">{{composition?.address?.zip}} {{composition?.address?.city}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.phone">{{composition?.address?.phoneLabel}} {{composition?.address?.phone}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.fax">{{composition?.address?.fax}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.email">{{composition?.address?.email}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.website">{{composition?.address?.website}}</mat-list-item>
    </mat-list>
  </div>
  <div>
    <h4>App</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.address?.appTitle">{{composition?.address?.appTitle}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.logo">{{composition?.address?.logo}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.background">{{composition?.address?.background}}</mat-list-item>
      <mat-list-item *ngIf="composition?.address?.favIcon">{{composition?.address?.favIcon}}</mat-list-item>
    </mat-list>
  </div>
  <div>
    <h4>Coordinates</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.location?.coordinates">
        Latitude: {{composition?.location?.coordinates[0]}}
        Longitude: {{composition?.location?.coordinates[1]}}
      </mat-list-item>
    </mat-list>
  </div>
  <div>
    <h4>Tracking</h4>
    <mat-list>
      <mat-list-item *ngIf="composition?.gaTrackingId">
        Google Analytics UA-Code: {{composition?.gaTrackingId}}
      </mat-list-item>
    </mat-list>
  </div>
</div>
